export default __webpack_public_path__ + "static/media/atendimento.9f62fc88.svg";